import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../assets/logo/ink.png';
import '../../styles/MinimalHeader.css';

const MinimalHeader = () => {
  return (
    <header className="minimal-header">
      <div className="minimal-header-container">
        <Link to="/" className="minimal-logo-link">
          <img src={logo} alt="DKL Books" className="minimal-logo" />
        </Link>
        
      </div>
    </header>
  );
};

export default MinimalHeader;
